export default __webpack_public_path__ + "static/media/NF.40fe81d1.svg";